export const SHOW_SUCCESS_SNACKBAR = "SHOW_SUCCESS_SNACKBAR";
export const SHOW_WARNING_SNACKBAR = "SHOW_WARNING_SNACKBAR";
export const HIDE_SNACKBAR = "HIDE_SNACKBAR";
export const SHOW_ERROR_SNACKBAR = "SHOW_ERROR_SNACKBAR";
export const SHOW_INFO_SNACKBAR = "SHOW_INFO_SNACKBAR";